var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPaintBrush = function SvgPaintBrush(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1322_6515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 10.5H20.25",
    stroke: "#1374CF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 14.25C4.85218 14.25 4.47064 14.092 4.18934 13.8107C3.90804 13.5294 3.75 13.1478 3.75 12.75V6C3.75 5.20435 4.06607 4.44129 4.62868 3.87868C5.19129 3.31607 5.95435 3 6.75 3H20.25V12.75C20.25 13.1478 20.092 13.5294 19.8107 13.8107C19.5294 14.092 19.1478 14.25 18.75 14.25H14.25C14.1426 14.25 14.0364 14.2731 13.9386 14.3177C13.8409 14.3623 13.7538 14.4274 13.6834 14.5085C13.613 14.5897 13.5609 14.685 13.5305 14.7881C13.5002 14.8912 13.4923 14.9996 13.5075 15.1059L14.25 19.5C14.25 20.0967 14.0129 20.669 13.591 21.091C13.169 21.5129 12.5967 21.75 12 21.75C11.4033 21.75 10.831 21.5129 10.409 21.091C9.98705 20.669 9.75 20.0967 9.75 19.5L10.4925 15.1059C10.5077 14.9996 10.4998 14.8912 10.4695 14.7881C10.4391 14.685 10.387 14.5897 10.3166 14.5085C10.2462 14.4274 10.1591 14.3623 10.0614 14.3177C9.96364 14.2731 9.85744 14.25 9.75 14.25H5.25Z",
    stroke: "#1374CF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 3V7.5",
    stroke: "#1374CF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1322_6515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaintBrush, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paint_brush.00ca4441.svg";
export { ForwardRef as ReactComponent };